<div
  class="avatar"
  [style.width.px]="size"
  [style.height.px]="size"
  [style.font-size.px]="fontSize"
  [style.background-color]="color"
  [style.color]="textColor">
  @if (iconUrl) {
    <span class="avatar__icon-badge">
      <img class="avatar__icon" [src]="iconUrl" alt="" />
    </span>
  } @else {
    {{ initials }}
    @if (photoUrl && !photoFailed) {
      <img
        class="avatar__photo"
        [class.avatar__photo--visible]="photoLoaded"
        [src]="photoUrl"
        alt=""
        (load)="photoLoaded = true"
        (error)="photoFailed = true" />
    }
  }
</div>
